import { render, staticRenderFns } from "./ECom.vue?vue&type=template&id=08c8e3e8&"
import script from "./ECom.vue?vue&type=script&lang=js&"
export * from "./ECom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports